import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { FormattedStat } from '@/shared/constants/types'
import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'
import { $xboxUserData } from '@/entities/platforms/xbox'

function useGetXboxStats() {
  const userLang = useUnit($userLanguage)

  const texts = lang[userLang].pages.xboxProfile.stats
  const xboxData = useUnit($xboxUserData)

  const [stats, setStats] = useState<FormattedStat[]>([])

  useEffect(() => {
    setStats([
      { name: texts.gamerScore, value: `${xboxData?.achievements?.gamerscore ?? 0}` },
      {
        name: texts.achievements,
        value: xboxData?.achievements?.total_earned ?? 0,
        diff: '0',
      },
      {
        name: texts.gamesOwned,
        value: xboxData?.games.length ?? 0,
        diff: '0',
      },
      { name: texts.averageProgress, value: `${xboxData?.average_progress ?? 0}%` },
    ])
  }, [userLang, xboxData])

  return stats
}

export default useGetXboxStats
